import { render } from "./ProjectManagementJobDetail.vue?vue&type=template&id=0770b0c6&scoped=true"
import script from "./ProjectManagementJobDetail.vue?vue&type=script&lang=js"
export * from "./ProjectManagementJobDetail.vue?vue&type=script&lang=js"

import "./ProjectManagementJobDetail.vue?vue&type=style&index=0&id=0770b0c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0770b0c6"]])

export default __exports__